import { render, staticRenderFns } from "./time-off-view.vue?vue&type=template&id=05f9820a&scoped=true&"
import script from "./time-off-view.vue?vue&type=script&lang=js&"
export * from "./time-off-view.vue?vue&type=script&lang=js&"
import style0 from "./time-off-view.vue?vue&type=style&index=0&id=05f9820a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9820a",
  null
  
)

export default component.exports